import { useAppSelector } from "State/Store";

export const useUser = () => useAppSelector(s => s.auth.session.user);
